'use client';

import { useMemo } from 'react';
import { Text, VStack } from '@chakra-ui/react';

import { Button } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import * as AppLayout from 'components/AppLayout';

interface Props {
  giftcard: AdaptedGiftcard;
  onActivate(): void;
  isLoading: boolean;
  isActivationOpen: boolean;
}

export const ActivateGiftcardForm = (props: Props) => {
  const { giftcard, onActivate, isLoading, isActivationOpen } = props;

  const isActivateGiftcardButtonVisible = isActivationOpen;

  const { content } =
    usePageTextContent<SponsoredGiftcardActivationPageContent>();

  const {
    balance,
    activateUntil,
    giftcardLabel,
    activationExpiredDescription,
    activationDescription,
  } = content;

  const activateGiftcardButton = content.activateGiftcardButton.replace(
    '<<activationAmount>>',
    giftcard.activation.formatted.amount,
  );

  const description = useMemo(() => {
    if (!isActivationOpen) return activationExpiredDescription;

    return activationDescription.replace(
      '<<activationAmount>>',
      giftcard.activation.formatted.amount,
    );
  }, [isActivationOpen]);

  return (
    <>
      <AppLayout.InfoRow
        rows={[
          {
            key: 'giftcardContext',
            label: giftcardLabel,
            value: giftcard.contextName,
          },
        ]}
      />

      <AppLayout.InfoRow
        rows={[
          {
            key: 'balance',
            label: balance,
            value: giftcard.formatted.balance,
          },
          {
            key: 'activateUntil',
            label: activateUntil,
            value: giftcard.activation.formatted.sponsor.activationClosesAt,
          },
        ]}
      />

      <VStack align="flex-start" spacing="1rem">
        <Text fontSize="1.125rem">{description}</Text>

        {isActivateGiftcardButtonVisible && (
          <Button
            variant="network"
            size="lg"
            onClick={onActivate}
            isLoading={isLoading}
          >
            {activateGiftcardButton}
          </Button>
        )}
      </VStack>
    </>
  );
};
